import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import SettingsPage from "../components/SettingsPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const SettingsPageContainer = connect(mapStateToProps, mapDispatchToProps)(SettingsPage);

export default SettingsPageContainer;


// WEBPACK FOOTER //
// ./src/containers/SettingsPageContainer.js